import './ErrorPage.scss';

import { FormattedMessage } from 'react-intl';
import { Button, ButtonColor, ButtonVariant, Size } from '@eliberty/design-system-react';

import { getWidgetsConfig } from '~utils';

const ErrorPage = () => {
  // Get the base URL for static assets from the script source
  // Falls back to root path for Storybook where getWidgetsConfig returns undefined
  const scriptSrc = getWidgetsConfig('src');
  const baseUrl = scriptSrc ? scriptSrc.replace('/bundle.js', '') : '';
  const imageUrlToUse = `${baseUrl}/jeandoudou_sad.png`;

  const handleRetry = () => {
    globalThis.location.reload();
  };

  const handleGoHome = () => {
    globalThis.location.href = '/';
  };

  return (
    <div className='ErrorPage' role='alert' aria-live='assertive'>
      <img src={imageUrlToUse} alt='Sad detective' className='ErrorPage_image' />
      <h1 className='ErrorPage_title'>
        <FormattedMessage id='errorPageTitle' defaultMessage='Sorry, we have a problem...' />
      </h1>
      <p className='ErrorPage_message'>
        <FormattedMessage
          id='errorPageMessage1'
          defaultMessage='This isn’t how the story was supposed to go.'
        />
        <br />
        <FormattedMessage
          id='errorPageMessage2'
          defaultMessage='We’re on it and will have things back to normal shortly.'
        />
      </p>
      <div className='ErrorPage_actions'>
        <Button
          variant={ButtonVariant.Filled}
          color={ButtonColor.Black}
          size={Size.M}
          onClick={handleRetry}
        >
          <FormattedMessage id='refreshPage' defaultMessage='Refresh page' />
        </Button>
        <Button
          variant={ButtonVariant.Outlined}
          color={ButtonColor.Black}
          size={Size.M}
          leadingIcon='chevron-left'
          onClick={handleGoHome}
        >
          <FormattedMessage id='goBackToHome' defaultMessage='Go back to home' />
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
